import {Component, Input, OnInit} from '@angular/core';
import {TextUtils} from "../../../../../shared/utils/text-utils";

@Component({
    selector: 'db-orders-table',
    templateUrl: './orders-table.component.html',
    styleUrls: ['./orders-table.component.scss'],
    standalone: false
})
export class OrdersTableComponent implements OnInit {
  isMobile = false;
  showOrderNumberHeader = true;
  public heads: string[] = [
    TextUtils.getText('text_date'),
    TextUtils.getText('text_customer'),
    TextUtils.getText('text_total'),
    TextUtils.getText('text_transactionId'),
    TextUtils.getText('text_paymentStatus'),
    TextUtils.getText('text_orderStatusTable')
  ];
  @Input() isScrollingHorizontal: boolean;
  constructor() { }

  ngOnInit() {
  }

}
